module.exports = __webpack_public_path__ + "img/product-preview-50.95c4ec2.png";